"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Thumbnail = void 0;
var React = require("react");
var keyboard = require("../../_Core/Keyboard");
var Spinner_1 = require("../../Animations/Spinner");
var Icon_1 = require("../../Icons/Icon");
var PhotoViewer_1 = require("../../Internal/PhotoViewer");
var Center_1 = require("../../Layouts/Center");
var Theme_1 = require("../../Theme");
var Img_1 = require("./components/Img");
var UpdatePhotoOverlay_1 = require("./components/UpdatePhotoOverlay");
var Thumbnail_styles_1 = require("./Thumbnail.styles");
var BuildFontSize = function (size) {
    switch (size) {
        case "Smallest": return "8px";
        case "Small": return "10px";
        case "Normal": return "12px";
        case "Large": return "20px";
        case "Largest": return "20px";
    }
};
var BuildSize = function (size) {
    switch (size) {
        case "Smallest": return 32;
        case "Small": return 40;
        case "Normal": return 48;
        case "Large": return 80;
        case "Largest": return 96;
    }
};
var BuildShape = function (shape) {
    if (shape === "Circular") {
        return "50%";
    }
    else {
        return Theme_1.default.Thumbnail.SquareBorderRadius;
    }
};
exports.Thumbnail = React.forwardRef(function (_a, uploadPhotoRef) {
    var _b = _a.ShowLoading, ShowLoading = _b === void 0 ? true : _b, Role = _a.Role, AltText = _a.AltText, Size = _a.Size, Shape = _a.Shape, Src = _a.Src, Placeholder = _a.Placeholder, ShowUpload = _a.ShowUpload, OnUploadClick = _a.OnUploadClick, LoadNewSourceForPhotoViewer = _a.LoadNewSourceForPhotoViewer, _c = _a.PhotoViewerHeaderText, PhotoViewerHeaderText = _c === void 0 ? AltText : _c;
    var _d = React.useState(Src && ShowLoading ? "Loading" : "ShowAlternative"), state = _d[0], setState = _d[1];
    var _e = React.useState(false), isHoveredOrFocused = _e[0], setIsHoveredOrFocused = _e[1];
    var _f = PhotoViewer_1.usePhotoViewer(), PhotoViewer = _f.PhotoViewer, showPhotoViewer = _f.showPhotoViewer;
    var wrapperDivRef = React.createRef();
    var actualSize = BuildSize(Size);
    var actualShape = BuildShape(Shape);
    var actualFontSize = BuildFontSize(Size);
    var handleImageLoadSuccess = function () {
        setState("ShowImage");
    };
    var handleImageLoadFail = function () {
        setState("ShowAlternative");
    };
    var handleClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!LoadNewSourceForPhotoViewer) return [3 /*break*/, 2];
                    return [4 /*yield*/, showPhotoViewer(LoadNewSourceForPhotoViewer)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    if (!(state !== "ShowAlternative")) return [3 /*break*/, 4];
                    return [4 /*yield*/, showPhotoViewer(Src)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    wrapperDivRef.current.focus();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleOnKeyPress = function (e) {
        var target = e.target;
        if (keyboard.IsSpace(e) || keyboard.IsEnter(e)) {
            target.click();
        }
    };
    return React.createElement(React.Fragment, null,
        React.createElement(Thumbnail_styles_1.WrapperDiv, { ref: wrapperDivRef, FontSize: actualFontSize, BorderRadius: actualShape, Size: actualSize + "px", onClick: handleClick, IsClickable: !!LoadNewSourceForPhotoViewer || state !== "ShowAlternative", onKeyPress: handleOnKeyPress, onMouseEnter: ShowUpload ? function () { return setIsHoveredOrFocused(true); } : undefined, onMouseLeave: ShowUpload ? function () { return setIsHoveredOrFocused(false); } : undefined, onFocus: ShowUpload ? function () { return setIsHoveredOrFocused(true); } : undefined, onBlur: ShowUpload ? function () { return setIsHoveredOrFocused(false); } : undefined, tabIndex: ShowUpload ? undefined : 0, role: ShowUpload ? undefined : "button" },
            React.createElement(Img_1.default, { ShowImage: state === "ShowImage", AltText: AltText, Src: Src, Role: Role, OnLoad: handleImageLoadSuccess, OnError: handleImageLoadFail }),
            (state === "Loading") &&
                React.createElement(Thumbnail_styles_1.LoaderContainer, null,
                    React.createElement(Spinner_1.Spinner, { Size: actualFontSize })),
            (state === "ShowAlternative") && React.createElement(React.Fragment, null,
                typeof Placeholder === "string" && React.createElement(Center_1.Center, null,
                    React.createElement(Thumbnail_styles_1.P, { "aria-hidden": Role === "presentation" ? true : false }, Placeholder)),
                typeof Placeholder === "number" && React.createElement(Center_1.Center, null,
                    React.createElement(Icon_1.Icon, { Height: "3em", Width: "3em", Icon: Placeholder })),
                typeof Placeholder === "function" && React.createElement(Placeholder, { Size: actualSize })),
            ShowUpload &&
                React.createElement(UpdatePhotoOverlay_1.default, { ref: uploadPhotoRef, IsFullSize: state === "ShowAlternative", ActualSize: actualSize, Size: Size, Show: isHoveredOrFocused, OnUploadClick: OnUploadClick })),
        React.createElement(PhotoViewer, { AltText: AltText, ImgRole: Role, PopupHeader: PhotoViewerHeaderText }));
});
